import React, { Component } from "react";
import { ChangeEvent, useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import {
  Button,
  Typography,
  Switch,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { Box } from "@mui/system";
import "../components/styles/UploadFaxFile.css";
import DeleteIcon from "@mui/icons-material/Delete";
import { StylesProvider } from "@material-ui/core";
import Api_Call from "../ApiCall";
import menus from "../info.json";

const ControlPanel = () => {
  {
    const [crmode, setCrmode] = useState(true);
    const [isactive, setIsactive] = useState(false);
    const [validInput, setValidInput] = useState(true);
    const [cptcode, setCptCode] = useState("");
    const [precertlist, setPrecertList] = useState([]);
    const [filelist, setFileList] = useState([]);
    const [isLoading, setLoading] = useState(true);

    // Common URL
    const baseurl_configureCRMode =
      "https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/vcareui_configureenv";
    // Dev URL
    //const baseurl_configPreCert = "https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/vcareui_configureprecertlist";
    //const baseurl_resettasks = "https://wgacs73ce0.execute-api.us-east-1.amazonaws.com/dev/vcare_resettaskfeeder";
    //const env = "Dev";
    // QA URL
    const baseurl_configPreCert =
      "https://63japqerd7.execute-api.us-east-1.amazonaws.com/QA/zone2_vcareui_configureprecertlist";
    const baseurl_resettasks =
      "https://63japqerd7.execute-api.us-east-1.amazonaws.com/QA/zone2_vcare_resettaskfeeder";
    // Demo URL
    //const baseurl_configPreCert = "https://g934ehp5bj.execute-api.us-east-1.amazonaws.com/demo/demo_vcareui_configureprecertlist";
    //const baseurl_resettasks = "https://g934ehp5bj.execute-api.us-east-1.amazonaws.com/demo/reset_faxdata";

    // function to configure the value of toggle button
    const getCodesAndFiles = async () => {
      const api = new Api_Call();
      const data = await api.getData("CONFIG/MANAGEMENT", menus.BASE_URL_ADMIN);
      if (data.body.success == true) {
        toast.success(data.body.message, { autoClose: true });
        setFileList(data.body.file_list);
        console.log(data.body.codeList);
        const preCertArray =
          data.body.codeList[0] != null ? data.body.codeList[0].split(",") : [];
        setPrecertList(preCertArray);
        if (data.body.config.CR_mode == "1") {
          setIsactive(true);
        } else {
          setIsactive(false);
        }
      } else {
        toast.error(data.body.message, { autoClose: true });
      }
    };

    useEffect(() => {
      getCodesAndFiles();
      setLoading(false);
    }, []);

    const setCRHandle = (checked) => {
      // set the active state of the toggle button
      if (checked.target.checked) {
        setIsactive(true);
      } else {
        setIsactive(false);
      }
      console.log(" switch value ", checked.target.checked);
      setCrmode(checked);
      // call the function to update the config to backend
      configureCRMode(checked);
    };

    // function to check if the input CPT has only 5 digits
    const checkCptAssigned = (cptInput) => {
      const pattern = /^\d{5}$/;
      console.log(pattern.test(cptInput));
      setValidInput(!pattern.test(cptInput));
      setCptCode(cptInput);
    };

    // function to call the API for configuring the CR mode to backend
    const configureCRMode = async (cr_config) => {
      console.log(" switch value from handle ", cr_config);
      var config_value_api = "";
      if (cr_config.target.checked == true) {
        config_value_api = "1";
      } else {
        config_value_api = "0";
      }
      console.log("Config value ", config_value_api);
      const api = new Api_Call();
      const data = await api.postData(
        "CONFIG/MANAGEMENT",
        {
          config_value: "cr_config",
          field_name: "CR_mode",
          field_value: config_value_api,
        },
        menus.BASE_URL_ADMIN
      );
      if (data.body.success == true) {
        toast.success(data.body.message, { autoClose: true });
      }

      // axios
      //   .post(baseurl_configureCRMode, {
      //     operation: "update",
      //     field_name: "CR_mode",
      //     field_value: config_value_api,
      //     //environment: "Dev"
      //     environment: "QA",
      //   })
      //   .then((response) => {
      //     console.log(response);
      //     toast.success(response.data.body, { autoClose: true });
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    };

    //Configure pre cert list as per the user input
    //1. Common function to get the list of CPT configured in the system
    //2. Add and delete any CPT from the list
    const configureprecertlist = async (value, cpt) => {
      setPrecertList([]);
      var code = "";
      if (value == "") {
        code = "";
      } else {
        code = cpt["cptcode"];
      }
      const api = new Api_Call();
      const data = await api.postData(
        "CONFIG/MANAGEMENT",
        {
          precertCPT: code,
          config_value: value,
        },
        menus.BASE_URL_ADMIN
      );

      if (data.body.success === true) {
        //set the list of CPT configured to display it on UI
        const preCertArray = data.body.codeList[0].split(",");
        setPrecertList(preCertArray);
        toast.success(data.body.message, { autoClose: true });
        //clear the input text box everytime cpt is added successfully
        setCptCode("");
      } else {
        toast.error(data.body.message, { autoClose: true });
      }

      // axios
      //   .post(baseurl_configPreCert, {
      //     precertCPT: code,
      //     operation: value,
      //   })
      //   .then((response) => {
      //     if (response.data.body.success === true) {
      //       //set the list of CPT configured to display it on UI
      //       const preCertArray = response.data.body.codeList[0].split(",");
      //       setPrecertList(preCertArray);
      //       toast.success(response.data.body.message, { autoClose: true });
      //       //clear the input text box everytime cpt is added successfully
      //       setCptCode("");
      //     } else {
      //       toast.error(response.data.body.message, { autoClose: true });
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    };

    //function to get the already configured value in the system for CR mode
    //this returns true/false when the page loads to update the state of toggle button
    const getCRConfigValue = () => {
      axios
        .post(baseurl_configureCRMode, {
          operation: "get",
          //environment: "Dev"
          environment: "QA",
        })
        .then((response) => {
          //set the active state of the toggle button based on the
          //input received from the backend
          if (response.data.body.config == "1") {
            setIsactive(true);
          } else {
            setIsactive(false);
          }
          toast.success(response.data.body.msg, { autoClose: true });
        })
        .catch((error) => {
          console.log(error);
        });
    };
    const deleteCPT = async (config_value, cpttodelete) => {
      const api = new Api_Call();
      const data = await api.deleteData(
        "CONFIG/MANAGEMENT",
        {
          config_value: config_value,
          precertCPT: cpttodelete,
        },
        menus.BASE_URL_ADMIN
      );
      if (data.body.success === true) {
        //set the updated list of files after deletion for displaying it on UI
        const preCertArray =
          data.body.codeList[0] != null ? data.body.codeList[0].split(",") : [];
        setPrecertList(preCertArray);
        toast.success(data.body.message, { autoClose: true });
      } else {
        toast.error(data.body.message, { autoClose: true });
      }
    };
    //function to delete specific fax files uploaded on s3
    const deletefiles = async (config_value, filetodelete) => {
      let file_arr = [];
      file_arr.push(filetodelete["file"]);

      const api = new Api_Call();
      const data = await api.deleteData(
        "CONFIG/MANAGEMENT",
        {
          config_value: config_value,
          file: filetodelete,
        },
        menus.BASE_URL_ADMIN
      );
      if (data.body.success === true) {
        //set the updated list of files after deletion for displaying it on UI
        const list_files = data.body.file_list;
        setFileList(list_files);
        toast.success(data.body.message, { autoClose: true });
      } else {
        toast.error(data.body.message, { autoClose: true });
      }

      // axios
      //   .post(baseurl_resettasks, {
      //     operation: "delete",
      //     file: file_arr,
      //   })
      //   .then((response) => {
      //     if (response.data.body.success === true) {
      //       //set the updated list of files after deletion for displaying it on UI
      //       const list_files = response.data.body.file_list;
      //       setFileList(list_files);
      //       toast.success(response.data.body.message, { autoClose: true });
      //     } else {
      //       toast.error(response.data.body.message, { autoClose: true });
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    };

    //function called on page load. Gets the list of files existing on s3 bucket
    const getFilesList = () => {
      axios
        .post(baseurl_resettasks, {
          operation: "get",
        })
        .then((response) => {
          if (response.data.body.success === true) {
            //set the existing list of files for displaying it on UI
            const list_files = response.data.body.file_list;
            setFileList(list_files);
            toast.success(response.data.body.message, { autoClose: true });
          } else {
            toast.error(response.data.body.message, { autoClose: true });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    //called on page load event to get the configured value of cr mode,
    // list of configured Pre Cert CPT list and list of fax files uploaded
    // useEffect(() => {
    //  getCRConfigValue();
    //   configureprecertlist("", "");
    //   getFilesList();
    //   setLoading(false);
    // }, []);

    if (isLoading) {
      return (
        <div>
          <Box className="loader-wrapper">
            <div className="loader"></div>
          </Box>
        </div>
      );
    } else {
      return (
        <>
          <Box className="faxUpload-container">
            <Typography variant="h4">Control Panel</Typography>
            <table className="tableDisplay">
              <tr className="tableRow">
                <td> Care Radius Configuration for Create Auth </td>
                <td className="tableColumn">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          crconfig={crmode}
                          onChange={setCRHandle}
                          checked={isactive}
                        />
                      }
                      label={
                        isactive
                          ? "Auth ID from Care Radius"
                          : "Auth ID from Internal/vCare"
                      }
                    />
                  </FormGroup>
                </td>
              </tr>
              <tr className="tableRow">
                {" "}
                <td> Pre Cert CPT Code </td>
                <td>
                  <TextField
                    sx={{ paddingTop: "5px", paddingBottom: "5px" }}
                    autoFocus
                    id="pre cert cpt"
                    type="text"
                    value={cptcode}
                    onChange={(e) => checkCptAssigned(e.target.value)}
                  />{" "}
                  &nbsp;
                  <Button
                    sx={{ marginTop: "12px" }}
                    variant="contained"
                    disabled={validInput}
                    onClick={() =>
                      configureprecertlist("precertCPT", { cptcode })
                    }
                  >
                    Add CPT
                  </Button>
                </td>
              </tr>
              <tr className="tableRow">
                {" "}
                <td> Configured Pre Cert CPT List </td>
                <td>
                  <div>
                    <table className="tablestyle">
                      {precertlist.map((cptcode) => (
                        <tr>
                          <td width="50%">{cptcode}</td>
                          <td>
                            <Button
                              onClick={() =>
                                // configureprecertlist("Delete", { cptcode })
                                deleteCPT("deletecpt", cptcode)
                              }
                            >
                              <DeleteIcon />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </table>
                  </div>
                </td>
              </tr>
              <tr className="tableRow">
                {" "}
                <td> Uploaded Files </td>
                <td>
                  <div>
                    <table className="tablestyle">
                      {filelist.map((file) => (
                        <tr>
                          <td width="50%">{file}</td>
                          <td>
                            <Button
                              onClick={() => deletefiles("deletefile", file)}
                            >
                              <DeleteIcon />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </table>
                  </div>
                </td>
              </tr>
            </table>
          </Box>
        </>
      );
    }
  }
};
export default ControlPanel;
